// FE#285 — optimistic task delete must be a SOFT delete.
//
// The delete-task-list undo action used to optimistically HARD-remove the tasks
// (`removeMany`) before the recycle round-trip set `deleted:true` server-side.
// A realtime `patch` event for a just-removed id then hit NotiferHandlers'
// `case 'patch'` → the entity was no longer in the store → the `else` branch
// re-added it via unguarded `addOne`, resurrecting it in its pre-delete
// (`deleted:false`) state → the tasks flashed back ~a split second later.
//
// Marking `deleted:true` instead keeps the row in the store (hidden by the
// board's `deleted:false` filter), so a realtime patch for it is routed through
// the version-guarded `conditionalUpdateOne` — a stale echo at the same version
// is dropped and the task never reappears.

export interface SoftDeleteUpdate {
    id: string;
    changes: { deleted: true };
}

/**
 * The `updateMany` payload that soft-deletes every selected task id. Pure so the
 * FE#285 invariant ("optimistic delete is a soft delete, never a hard remove")
 * is unit-testable without the store/thunk machinery.
 */
export function buildOptimisticSoftDeletePayload(taskIdList: string[]): SoftDeleteUpdate[] {
    return taskIdList.map((id) => ({ id, changes: { deleted: true } }));
}
